export { default } from './integerPropType';
export * from './integerPropType';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/integerPropType/index.js
// module id = 58
// module chunks = 22